// extracted by mini-css-extract-plugin
export var alternate = "_1n-j";
export var black = "_1n-6";
export var blue = "_1n-f";
export var blueLight = "_1n-e";
export var brand = "_1n-8";
export var darkMode = "_1n-b";
export var error = "_1n-a";
export var gray = "_1n-5";
export var grayBlue = "_1n-d";
export var iconWrapper = "_1n-3";
export var inactive = "_1n-7";
export var indigo = "_1n-g";
export var orange = "_1n-i";
export var pink = "_1n-h";
export var primary = "_1n-0";
export var purple = "_1n-9";
export var success = "_1n-4";
export var warning = "_1n-c";
export var white = "_1n-1";
export var whiteSuccess = "_1n-2";